module.exports = __webpack_public_path__ + "58fbb2517dee70a839bcfa6d2ade0cfa.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/remax.png
// module id = 589
// module chunks = 0